import { useTranslation } from 'react-i18next'

const base =
  'inline-flex shrink-0 items-center rounded-[100px] font-[family-name:var(--stryzh-font-family-inter)] text-[length:var(--stryzh-font-size-xs)] font-medium uppercase tracking-[0.5px]'

export function CompanyStatusBadge({
  isActive,
  compact,
}: {
  isActive: boolean
  /** Узкий отступ для строк таблиц */
  compact?: boolean
}) {
  const { t } = useTranslation()
  const pad = compact ? 'px-2 py-0.5' : 'px-3 py-1'
  return (
    <span
      className={
        isActive
          ? `${base} ${pad} border border-[rgba(247,147,26,0.2)] bg-[rgba(247,147,26,0.12)] text-[color:var(--stryzh-color-accent-orange)]`
          : `${base} ${pad} border border-[rgba(255,255,255,0.08)] bg-[rgba(255,255,255,0.05)] text-[color:var(--stryzh-color-text-secondary)]`
      }
    >
      {isActive ? t('companies.statusActive') : t('companies.statusInactive')}
    </span>
  )
}
